import colors from '@/themes/colors/colors';

// This object act as an "interface" to the themes. If any theme property is changed or added, make sure to at least update this!
export default Object.freeze({
  name: 'N/A',
  background: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  border: {
    color: colors.red,
    variant: {
      color: colors.red,
    },
  },
  shadow: {
    color: colors.red,
    variant: {
      color: colors.red,
    },
  },
  primary: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  accent: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  accentComplementary: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  success: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  danger: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  warn: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  info: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  contrast: {
    bg: colors.red,
    text: colors.red,
    textDiscrete: colors.red,
    textAltColor: colors.red,
    variant: {
      bg: colors.red,
      text: colors.red,
      textDiscrete: colors.red,
      textAltColor: colors.red,
    },
  },
  menu: {
    moduleCategory: {
      text: colors.red,
    },
    module: {
      text: colors.red,
      highlightBg: colors.red,
      activeBg: colors.red,
    },
    subModule: {
      text: colors.red,
    },
  },
  subMenu: {
    opacity: '0',
  },
  input: {
    bg: colors.red,
    border: colors.red,
    text: colors.white,
    active: {
      bg: colors.red,
      border: colors.red,
    },
    danger: {
      bg: colors.red,
      border: colors.red,
    },
    warn: {
      bg: colors.red,
      border: colors.red,
    },
    hover: {
      bg: colors.red,
      border: colors.red,
    },
    alt: {
      text: colors.red,
    },
  },
  misc: {
    salesTools: {
      socialSelling: colors.red,
      trafficBooster: colors.red,
      outdoorAds: colors.red,
      webAds: colors.red,
    },
    landingPage: {
      createEventIcon: colors.red,
      comfortPackageIcon: colors.red,
      supportIcon: colors.red,
      myEventsIcon: colors.red,
      salesToolsIcon: colors.red,
      addProductIcon: colors.red,
      norticLivePaymentsIcon: colors.red,
      discoverNorticApps: colors.red,
    },
    productVariantColors: {
      0: colors.red,
      1: colors.red,
      2: colors.red,
    },
  },
});
